import { SVGProps } from 'react';

export const Alert = ({
  width = 24,
  height = 24,
  fill = '#FFCC4D',
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill={fill} />
      <path
        d="M12.25 5V14"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="12.25" cy="18.75" r="1.25" fill="white" />
    </svg>
  );
};
